<template>
  <div>
    <v-layout
      :wrap="$vuetify.breakpoint.xs"
      class="mb-4"
    >
      <v-flex
        xs="12"
        sm="6"
        class="grow-1"
      >
        <weekdays-picker
          :weekdays.sync="weekDaysModel"
          :title="$t('chooseWeekdays')"
          show-workdays-button
          show-saturday-button
        />
      </v-flex>
      <v-flex
        xs="12"
        md="6"
        class="grow-1"
      >
        <v-layout
          nowrap
          align-baseline
          :class="{
            'mt-4': $vuetify.breakpoint.xs,
            'mt-2': $vuetify.breakpoint.smAndUp,
          }"
        >
          <time-picker
            v-if="currentMode == MODE_TIME.value"
            :time.sync="timeModel"
            :title="$t('chooseTime')"
            :minute-step-size="1"
            class="mr-2"
          />
          <v-text-field
            v-if="currentMode === 'closingtime_minutes_before_closing'"
            v-model="minutesBeforeClosingModel"
            type="number"
            :min="minutesBeforeClosingMinimum"
            :max="minutesBeforeClosingMaximum"
            :step="minutesBeforeClosingStep"
            :title="$t('setClosingtimeMinutesBeforeClosing')"
            data-cy="closingtime-minutes-textfield"
            :rules="[
              rules.minutesBeforeClosingMin,
              rules.minutesBeforeClosingMax,
            ]"
            class="pt-2"
            style="max-width: 60px"
          />
          <v-select
            v-if="showTimePicker"
            v-model="currentMode"
            :items="modes"
            hide-details
            solo
            flat
            style="flex: 0"
          />
          <div
            v-else
            class="subheading"
            style="padding-left: 12px"
          >
            {{ $t('setClosingtimeMinutesBeforeClosing') }}
          </div>
        </v-layout>
        <v-slide-y-transition>
          <div
            v-if="showTimePicker && currentMode == MODE_MINUTES.value"
            class="warning--text mt-2"
          >
            <div>
              {{ $t('setClosingTimeTimeWarning') }}
            </div>
          </div>
        </v-slide-y-transition>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import TimePicker from '@/components/TimePicker';
import WeekdaysPicker from '@/components/WeekdaysPicker';

export default {
  components: {
    TimePicker,
    WeekdaysPicker,
  },
  props: {
    showTimePicker: {
      type: Boolean,
      default: false,
    },
    weekDays: {
      type: Array[Number],
      required: true,
    },
    time: {
      type: String,
      default: null,
    },
    minutesBeforeClosing: {
      type: [String, Number],
      default: null,
    },
    /**
     * Can be used with .sync to communicate form validation status back to parent.
     */
    formIsValid: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    const MODE_TIME = {
      value: 'closingtime_time',
      text: this.$t('setClosingtimeTime'),
    };
    const MODE_MINUTES = {
      value: 'closingtime_minutes_before_closing',
      text: this.$t('setClosingtimeMinutesBeforeClosing'),
    };

    return {
      MODE_MINUTES: MODE_MINUTES,
      MODE_TIME: MODE_TIME,
      modes: [MODE_MINUTES, MODE_TIME],
      currentMode: this.showTimePicker ? MODE_TIME.value : MODE_MINUTES.value,
    };
  },
  computed: {
    minutesBeforeClosingStep() {
      return 1;
    },
    minutesBeforeClosingMinimum() {
      return 1;
    },
    minutesBeforeClosingMaximum() {
      return 60;
    },
    rules() {
      const valueMin = this.minutesBeforeClosingMinimum;
      const valueMax = this.minutesBeforeClosingMaximum;
      const tooLow = this.$t('invalidNumberTooLow');
      const tooHigh = this.$t('invalidNumberTooHigh');
      return {
        minutesBeforeClosingMin: (v) => v >= valueMin || tooLow,
        minutesBeforeClosingMax: (v) => v <= valueMax || tooHigh,
      };
    },
    /**
     * Wrap props so that we can sync updates upwards properly.
     */
    weekDaysModel: {
      get() {
        return this.weekDays;
      },
      set(value) {
        this.$emit('update:weekDays', value);
      },
    },
    timeModel: {
      get() {
        return this.time || '';
      },
      set(value) {
        this.$emit('update:time', value);
      },
    },
    minutesBeforeClosingModel: {
      get() {
        return this.minutesBeforeClosing;
      },
      set(value) {
        this.$emit('update:minutesBeforeClosing', value);
      },
    },
    formIsValidModel() {
      const weekDaysOk = this.weekDays.length > 0;
      const timeOk = !!this.time;
      const minutesBeforeClosingOk =
        this.minutesBeforeClosing >= this.minutesBeforeClosingMinimum &&
        this.minutesBeforeClosing <= this.minutesBeforeClosingMaximum;
      return weekDaysOk && (timeOk || minutesBeforeClosingOk);
    },
  },
  watch: {
    showTimePicker: function (show) {
      if (show) {
        this.currentMode = this.MODE_TIME.value;
      }
    },
    formIsValidModel: function (valid) {
      this.$emit('update:formIsValid', valid);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ClosingtimeControls.vue